import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "home w-full h-full relative mx-auto",
  style: {"width":"100%"}
}
const _hoisted_2 = { class: "flex items-center flex-column justify-between mb-4 px-4 py-4" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = { class: "flex items-center flex-column justify-between mb-4 px-4 py-4" }
const _hoisted_5 = { class: "flex items-center" }
const _hoisted_6 = { key: 6 }
const _hoisted_7 = { key: 7 }
const _hoisted_8 = {
  key: 0,
  class: "dashboard-container"
}
const _hoisted_9 = { id: "top-nav" }
const _hoisted_10 = {
  key: 0,
  class: "d-inline-flex align-center"
}
const _hoisted_11 = { class: "office-select min-w-[300px] mr-4" }
const _hoisted_12 = { class: "mb-2" }
const _hoisted_13 = { class: "doctorsSpeedDial" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 1,
  class: "mobileElemContainer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SettingsDialog = _resolveComponent("SettingsDialog")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_AppointmentDialog = _resolveComponent("AppointmentDialog")!
  const _component_VirtualKeyboard = _resolveComponent("VirtualKeyboard")!
  const _component_AnalyticsDialog = _resolveComponent("AnalyticsDialog")!
  const _component_NotesDialog = _resolveComponent("NotesDialog")!
  const _component_ProfileSettingsDialog = _resolveComponent("ProfileSettingsDialog")!
  const _component_ConfirmationDialog = _resolveComponent("ConfirmationDialog")!
  const _component_WaitingRoom = _resolveComponent("WaitingRoom")!
  const _component_Dashboard = _resolveComponent("Dashboard")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_speed_dial = _resolveComponent("v-speed-dial")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_MobileMenu = _resolveComponent("MobileMenu")!
  const _component_CheckedOutAppointments = _resolveComponent("CheckedOutAppointments")!
  const _component_CreateAppointmentModal = _resolveComponent("CreateAppointmentModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showSettings)
      ? (_openBlock(), _createBlock(_component_SettingsDialog, {
          key: 0,
          onCloseDialog: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showSettings = false))
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.newWindowOpen,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newWindowOpen) = $event)),
      persistent: "",
      "max-width": "500px",
      style: {"min-height":"700px","max-height":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _cache[26] || (_cache[26] = _createElementVNode("div", {
                class: "text-center",
                style: {"color":"#333333","margin-bottom":"20px"}
              }, [
                _createElementVNode("h1", {
                  class: "text-red-700 title",
                  style: {"font-size":"1.1em"}
                }, " The app was opened on another window! "),
                _createTextVNode(" Do you want to continue here? ")
              ], -1)),
              _createVNode(_component_v_btn, {
                onClick: _ctx.updateReloadAfterNewOpen,
                color: "#77ACFF",
                style: {"color":"white"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_v_icon, { size: 24 }, {
                      default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                        _createTextVNode("mdi-refresh", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[25] || (_cache[25] = _createElementVNode("span", { class: "mr-1" }, "Update and Reload", -1))
                  ])
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.differeceInTime,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.differeceInTime) = $event)),
      persistent: "",
      "max-width": "500px",
      style: {"min-height":"700px","max-height":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _cache[29] || (_cache[29] = _createElementVNode("div", {
                class: "text-center",
                style: {"color":"#333333","margin-bottom":"20px"}
              }, [
                _createElementVNode("h1", {
                  class: "text-red-700 title",
                  style: {"font-size":"1.1em"}
                }, " Your computer has wrong time! "),
                _createTextVNode(" Please, synchronize time in your computer. ")
              ], -1)),
              _createVNode(_component_v_btn, {
                onClick: _ctx.updateReloadAfterNewOpen,
                color: "#77ACFF",
                style: {"color":"white"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_v_icon, { size: 24 }, {
                      default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                        _createTextVNode("mdi-refresh", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[28] || (_cache[28] = _createElementVNode("span", { class: "mr-1" }, "Reload", -1))
                  ])
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_ctx.showAppointment)
      ? (_openBlock(), _createBlock(_component_AppointmentDialog, {
          key: 1,
          onOnShowSettings: _ctx.onShowSettings
        }, null, 8, ["onOnShowSettings"]))
      : _createCommentVNode("", true),
    (_ctx.showVirtualKeyboard)
      ? (_openBlock(), _createBlock(_component_VirtualKeyboard, { key: 2 }))
      : _createCommentVNode("", true),
    (_ctx.showAnalytics)
      ? (_openBlock(), _createBlock(_component_AnalyticsDialog, {
          key: 3,
          onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showAnalytics = false))
        }))
      : _createCommentVNode("", true),
    (_ctx.showNotes)
      ? (_openBlock(), _createBlock(_component_NotesDialog, {
          key: 4,
          "show-notes": _ctx.showNotes,
          onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showNotes = false))
        }, null, 8, ["show-notes"]))
      : _createCommentVNode("", true),
    (_ctx.showProfileSettings)
      ? (_openBlock(), _createBlock(_component_ProfileSettingsDialog, {
          key: 5,
          onCloseProfileSettingsDialog: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showProfileSettings = false))
        }))
      : _createCommentVNode("", true),
    (_ctx.confirmation.uuid)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_ConfirmationDialog)
        ]))
      : _createCommentVNode("", true),
    (_ctx.viewBoard)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (_ctx.dashboard && _ctx.dashboard.rooms)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                (_ctx.queue && _ctx.queueUpcoming && _ctx.queueTomorrow)
                  ? (_openBlock(), _createBlock(_component_WaitingRoom, _normalizeProps(_mergeProps({ key: 0 }, { queue: _ctx.queue, queueUpcoming: _ctx.queueUpcoming, queueTomorrow: _ctx.queueTomorrow })), null, 16))
                  : _createCommentVNode("", true),
                _createVNode(_component_Dashboard)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      (!_ctx.isCompactWindow)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              (_ctx.offices && _ctx.offices.length)
                ? (_openBlock(), _createBlock(_component_v_select, {
                    key: 0,
                    class: "locationSelect mt-0 pt-0",
                    dense: "",
                    "hide-details": "",
                    items: _ctx.offices,
                    "item-title": "name",
                    "item-value": "uuid",
                    modelValue: _ctx.office,
                    "onUpdate:modelValue": [
                      _cache[6] || (_cache[6] = ($event: any) => ((_ctx.office) = $event)),
                      _ctx.onOfficeSelected
                    ],
                    variant: "plain",
                    density: "compact",
                    rounded: ""
                  }, {
                    "prepend-inner": _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        small: "",
                        color: "#056D97"
                      }, {
                        default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                          _createTextVNode("mdi-map-marker", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    selection: _withCtx(({ item }) => [
                      _createElementVNode("span", _hoisted_12, _toDisplayString(item.title.length > 35 ? item.title.substr(0, 34) + '...' : item.title), 1)
                    ]),
                    _: 1
                  }, 8, ["items", "modelValue", "onUpdate:modelValue"]))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_v_speed_dial, {
              modelValue: _ctx.fab,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.fab) = $event)),
              location: "top right",
              direction: "bottom",
              transition: "slide-y-reverse-transition",
              style: {"display":"inline-block"}
            }, {
              activator: _withCtx(({ props }) => [
                _createVNode(_component_v_btn, _mergeProps(props, {
                  color: "blue-darken-2",
                  theme: "dark",
                  icon: "",
                  size: "x-small",
                  class: "mr-2"
                }), {
                  default: _withCtx(() => [
                    (_ctx.fab)
                      ? (_openBlock(), _createBlock(_component_v_icon, {
                          key: 0,
                          size: 24
                        }, {
                          default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                            _createTextVNode("mdi-close", -1)
                          ]))]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (!_ctx.fab)
                      ? (_openBlock(), _createBlock(_component_v_icon, {
                          key: 1,
                          size: 24
                        }, {
                          default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                            _createTextVNode("mdi-account-multiple", -1)
                          ]))]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 16)
              ]),
              default: _withCtx(() => [
                (_ctx.filtered)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      icon: "",
                      size: "x-small",
                      color: "grey-lighten-2",
                      onClick: _ctx.resetFilter
                    }, {
                      default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                        _createTextVNode(" ALL ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_13, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.doctorsFormatted, (doctor, i) => {
                    return (_openBlock(), _createBlock(_component_v_btn, {
                      key: `doctor-filter-btn-${i}`,
                      icon: "",
                      theme: _ctx.filter === doctor.uuid ? 'dark' : 'light',
                      size: "x-small",
                      color: _ctx.filter === doctor.uuid ? '#48BB78' : 'grey-lighten-2',
                      onClick: ($event: any) => (_ctx.filterDashboard(doctor))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$filters.initials(doctor.name)), 1)
                      ]),
                      _: 2
                    }, 1032, ["theme", "color", "onClick"]))
                  }), 128))
                ])
              ]),
              _: 1
            }, 8, ["modelValue"]),
            (_ctx.viewAnalytics)
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 0,
                  class: "mr-2",
                  color: "teal",
                  icon: "",
                  size: "x-small",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showAnalytics = true))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      color: "white",
                      size: 18
                    }, {
                      default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                        _createTextVNode("mdi-chart-bar", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.configureBoard)
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 1,
                  class: "mr-2",
                  color: "#4E8EB1",
                  icon: "",
                  size: "x-small",
                  onClick: _ctx.onShowSettings
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      color: "white",
                      size: 18
                    }, {
                      default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                        _createTextVNode("mdi-cog", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true),
            _createVNode(_component_v_btn, {
              color: "purple",
              class: "mr-2",
              icon: "",
              size: "x-small",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showNotes = true))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  color: "white",
                  size: 18
                }, {
                  default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
                    _createTextVNode("mdi-bell", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_btn, {
              color: "red",
              class: "mr-2",
              icon: "",
              size: "x-small",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.toggleKeyboard()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  color: "white",
                  size: 18
                }, {
                  default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                    _createTextVNode("mdi-keyboard", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_btn, {
              class: "mr-2",
              icon: "",
              size: "x-small",
              onClick: _cache[11] || (_cache[11] = ($event: any) => {_ctx.$store.dispatch('TOGGLE_CHECKED_OUT_APPOINTMENTS_MODAL');})
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  color: "blue-darken-2",
                  size: 18
                }, {
                  default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
                    _createTextVNode("mdi-check", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_menu, {
              rounded: "lg",
              location: "bottom",
              "content-class": "profile-menu"
            }, {
              activator: _withCtx(({ props }) => [
                _createVNode(_component_v_btn, _mergeProps({
                  icon: "",
                  size: "x-small"
                }, props, {
                  color: "#116289",
                  class: "v-menu-btn"
                }), {
                  default: _withCtx(() => [
                    (!!_ctx.user)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.$filters.initials(_ctx.user.name)), 1))
                      : _createCommentVNode("", true),
                    (!_ctx.user)
                      ? (_openBlock(), _createBlock(_component_v_icon, { key: 1 }, {
                          default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                            _createTextVNode("mdi-account", -1)
                          ]))]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 16)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_v_list, null, {
                  default: _withCtx(() => [
                    (!!_ctx.user)
                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                          key: "keyOfProfile",
                          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.showProfileSettings = !_ctx.showProfileSettings))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  color: "black",
                                  size: 18
                                }, {
                                  default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                                    _createTextVNode("mdi-cog", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _cache[41] || (_cache[41] = _createTextVNode(" Settings ", -1))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_list_item, { key: "scheduler-link" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_title, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_router_link, {
                              to: { path: '/scheduler'},
                              tag: "button",
                              class: "mr-4",
                              color: "#4E8EB1",
                              fab: "",
                              "x-small": ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  color: "black",
                                  size: 18
                                }, {
                                  default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                                    _createTextVNode("mdi-calendar-account-outline", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _cache[43] || (_cache[43] = _createTextVNode(" Scheduler ", -1))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_list_item, {
                      key: "admin-link",
                      href: _ctx.adminPanelUrl,
                      target: "_blank"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_title, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, {
                              color: "black",
                              size: 18
                            }, {
                              default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                                _createTextVNode("mdi-account-supervisor", -1)
                              ]))]),
                              _: 1
                            }),
                            _cache[45] || (_cache[45] = _createTextVNode(" Admin Panel ", -1))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["href"]),
                    _createVNode(_component_v_list_item, {
                      key: "keyOfLogOut",
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$store.dispatch('authLogout')))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_title, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, {
                              color: "black",
                              size: 18
                            }, {
                              default: _withCtx(() => [...(_cache[46] || (_cache[46] = [
                                _createTextVNode("mdi-logout", -1)
                              ]))]),
                              _: 1
                            }),
                            _cache[47] || (_cache[47] = _createTextVNode(" Logout ", -1))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.isCompactWindow)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            (!_ctx.compactSpeedDial)
              ? (_openBlock(), _createBlock(_component_v_icon, {
                  key: 0,
                  onClick: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (_ctx.compactSpeedDial = !_ctx.compactSpeedDial), ["stop"]))
                }, {
                  default: _withCtx(() => [...(_cache[48] || (_cache[48] = [
                    _createTextVNode("mdi-dots-vertical", -1)
                  ]))]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.compactSpeedDial)
              ? (_openBlock(), _createBlock(_component_v_icon, {
                  key: 1,
                  onClick: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (_ctx.compactSpeedDial = !_ctx.compactSpeedDial), ["stop"]))
                }, {
                  default: _withCtx(() => [...(_cache[49] || (_cache[49] = [
                    _createTextVNode("mdi-close", -1)
                  ]))]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_v_snackbar, {
      modelValue: _ctx.successState,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.successState) = $event)),
      timeout: "1500"
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_v_btn, _mergeProps({
          color: "white",
          text: ""
        }, _ctx.attrs, {
          onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.successState = false))
        }), {
          default: _withCtx(() => [...(_cache[50] || (_cache[50] = [
            _createTextVNode(" Close ", -1)
          ]))]),
          _: 1
        }, 16)
      ]),
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.successStateText) + " ", 1)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_snackbar, {
      modelValue: _ctx.errorState,
      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.errorState) = $event)),
      color: "error",
      timeout: "1500"
    }, {
      action: _withCtx(({ attrs }) => [
        _createVNode(_component_v_btn, _mergeProps({
          color: "white",
          text: ""
        }, attrs, {
          onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.errorState = false))
        }), {
          default: _withCtx(() => [...(_cache[51] || (_cache[51] = [
            _createTextVNode(" Close ", -1)
          ]))]),
          _: 1
        }, 16)
      ]),
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.errorStateText) + " ", 1)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_MobileMenu, {
      "compact-menu-open": _ctx.compactSpeedDial,
      onToggleAnalytic: _cache[20] || (_cache[20] = ($event: any) => (_ctx.showAnalytics = !_ctx.showAnalytics)),
      onOnShowSettings: _ctx.onShowSettings,
      onProfileSettings: _cache[21] || (_cache[21] = ($event: any) => (_ctx.showProfileSettings = !_ctx.showProfileSettings)),
      onShowNotes: _cache[22] || (_cache[22] = ($event: any) => (_ctx.showNotes = true)),
      onFilterByDoctor: _ctx.filterDashboard,
      onResetDoctorFilter: _ctx.resetFilter,
      onCompactSpeedDeal: _cache[23] || (_cache[23] = ($event: any) => (_ctx.compactSpeedDial = !_ctx.compactSpeedDial))
    }, null, 8, ["compact-menu-open", "onOnShowSettings", "onFilterByDoctor", "onResetDoctorFilter"]),
    _createVNode(_component_CheckedOutAppointments),
    (_ctx.createAppointmentModal)
      ? (_openBlock(), _createBlock(_component_CreateAppointmentModal, { key: 8 }))
      : _createCommentVNode("", true)
  ]))
}